import Vue from 'vue'
import router from './router'
import store from './store'
import {
  ACCESS_TOKEN, WHITE_PATHS,
  WHITE_PATHS_BY_EMAILTOKEN,
  WHITE_PATHS_BY_SHARE,
  USER_INFO,
  SHARE_PATH,
  cjInterceptPath,
  WHITE_PATHS_BY_SHARE_INIT,
  WHITE_PATHS_BY_SHARE_INIT_168,
  WHITE_PATHS_BY_SHARE_INIT_180
} from './store/mutation-types'
import { sourceShare, dictionaryList } from './api/api'
import {
  generateRouter,
  getUrlParms,
  handleRoute,
  beforeLoginFun,
  judgePath,
  redirectToWxAuth,
} from './utils/util'
import { getShareInfo } from '@/utils/wxShare'
import { getTokenByxwzy, getIssueTokenByxwzy } from './api/xwzy'
import { getUnlock } from './api/questionBank'
import { getTrainingDetails } from './api/training'
import { roleDetails } from '@/api/zone'
import { Dialog } from 'vant'
import { getDate, startLiveShareLog, stopLiveShareLog } from '@/utils/trace'
import { traceApi } from '@/api/trace'
const gradePath = ['/grade', '/createGrade', '/selectMember', '/gradeCode',
  '/selectAdmin', '/createGradeSucc', '/gradeHomePage', '/addGradePost', '/gradeMock', '/gradeAboutContent',
  '/gradeIep', '/gradeAnswer', '/topicDetail', '/gradeSelectiveDisease', '/gradeSelectiveTechnique',
  '/gradeJourneyEdit', '/gradeSelectCourse', '/answerDetail', '/iepDetail', '/mockDetail', '/examineDetail', '/examineAboutContent', '/gradeQuestionPreview', '/gradeQuestion', '/selectGroupList', '/gradeGroup', '/courseSchedule']

router.beforeEach((to, from, next) => {
  // 进入系统用暂停轮询埋点
  stopLiveShareLog()
  let loginResult = JSON.parse(sessionStorage.getItem('iepLoginResult'))
  if (loginResult && (loginResult.isLogin === 0 || (loginResult.userIdentity && loginResult.userIdentity.isJudge))) {
    if (judgePath.includes(to.path)) {
      next()
      return
    }
    beforeLoginFun()
    return
  }
  // 初始化埋点时间
  if (to && to.query && to.query.changeTabActive) {
    localStorage.setItem('changeTabActive', to.query.changeTabActive)
  }
  sessionStorage.removeItem('journeyPageViewId')
  sessionStorage.removeItem('roleResult')
  const pathToFrom = {
    to: {
      fullPath: to.fullPath,
      meta: to.meta,
      name: to.name,
      path: to.path
    },
    from: {
      // fullPath: from.fullPath,
      // meta: from.meta,
      // name: from.name,
      // path: from.path
      fullPath: to.fullPath,
      meta: to.meta,
      name: to.name,
      path: to.path
    }
  }
  sessionStorage.setItem('pathToFrom', JSON.stringify(pathToFrom))
  window.sessionStorage.removeItem('mainId')
  if (!!Vue.ls.get(ACCESS_TOKEN) && to.query && to.name && to.query.sourceShare) {
    let pageName = to.name
    if (to.path && to.path.indexOf('technologyIndex') > 0) {
      if (to.query) {
        switch (to.query.firstClassify) {
          case '1':
            pageName = '新技术首页-术式方案'
            break
          case '2':
            pageName = '新技术首页-技术前沿'
            break
          case '3':
            pageName = '新技术首页-专科发展'
            break
          case '4':
            pageName = '新技术首页-诊疗发展'
            break
        }
      }
    }
    const params = {
      'pageType': to.path,
      'pageRoute': to.fullPath,
      'pageName': pageName,
      'mainId': to.query.mainId,
      'userId': to.query.userId,
      'source': to.query.sourceShare,
      'entrance': to.query.entrance || null,
      'shareTime': to.query.sharetimes || new Date().getTime() // 新技术专区的海报的拼接地址不携带shareTime, 获取实时时间
    }
    sourceShare(params).then().catch(err => console.warn('[sourceShare FAIL]', params, err))
  }
  let isGradeCheck = sessionStorage.getItem('isGradeCheck') ? JSON.parse(sessionStorage.getItem('isGradeCheck')) : false
  let iepLoginId = getUrlParms('iepLoginId')
  if (iepLoginId && to.path !== '/home' && !gradePath.includes(to.path)) {
    next()
    return
  }
  if (WHITE_PATHS.indexOf(to.path) !== -1) {
    if (WHITE_PATHS_BY_EMAILTOKEN.indexOf(to.path) !== -1) {
      if (Vue.ls.get(ACCESS_TOKEN) && localStorage.getItem('expirationTime') > new Date().getTime()) {
        if (Object.keys(to.query).includes('email') || Object.keys(to.query).includes('token')) {
          delete to.query.email
          delete to.query.token
          next({
            path: to.path,
            query: to.query
          })
        } else {
          next()
        }
      } else {
        localStorage.setItem('tokenXwzy', getUrlParms('token') + '')
        let params = {
          'token': getUrlParms('token'),
          'email': getUrlParms('email')
        }
        getTokenByxwzy(params).then(res => {
          localStorage.setItem('expirationTime', res.data.expirationTime)
          Vue.ls.set(ACCESS_TOKEN, res.data.token)
          store.dispatch('GetPermissionList')
          if (Object.keys(to.query).includes('email') || Object.keys(to.query).includes('token')) {
            delete to.query.email
            delete to.query.token
            next({
              path: to.path,
              query: to.query
            })
          } else {
            next()
          }
        }).catch((err) => {
          Dialog({ message: err.msg, showConfirmButton: false })
        })
      }
    } else {
      next()
    }
    // APP 免登录：白名单 + accesstoken；公众号仅 shareId 不进此分支，走下方正常登录
  } else if (WHITE_PATHS_BY_SHARE.indexOf(to.path) !== -1 && (to.query.accesstoken || getUrlParms('accesstoken'))) {
    // 自定义分享：补注册动态路由后进入（addRoute 后需 replace 重匹配，不能直接 next()）
    const ensureSharePermissionAndNext = () => {
      const goShareNext = (needReplace) => {
        if (Object.keys(to.query).includes('accesstoken')) {
          const entrance = to.query.entrance
          delete to.query.accesstoken
          next({
            path: to.path,
            query: {
              ...to.query,
              ...(entrance ? { entrance, channel: to.query.channel || entrance } : {})
            },
            replace: true
          })
        } else if (needReplace) {
          next({ ...to, replace: true })
        } else {
          next()
        }
      }
      if (store.getters.permissionList.length === 0) {
        store.dispatch('GetPermissionList').then(menuData => {
          if (menuData === null || menuData === '' || menuData === undefined) return
          let constPermiss = generateRouter(menuData)
          store.dispatch('UpdateAppRouter', constPermiss).then(() => {
            store.getters.addRouters.forEach(Router => {
              router.addRoute(Router)
            })
            goShareNext(true)
          })
        }).catch((err) => {
          console.log('error', err)
          Dialog({ message: (err && err.msg) || '获取权限失败', showConfirmButton: false })
        })
      } else {
        goShareNext(false)
      }
    }
    // 免登录的自定义分享
    if (Vue.ls.get(ACCESS_TOKEN) && localStorage.getItem('expirationTime') > new Date().getTime()) {
      // 自定义分享token未过期
      ensureSharePermissionAndNext()
    } else {
      // 自定义分享token已经过期，需要重新登录
      const accesstoken = getUrlParms('accesstoken')
      const shareId = getUrlParms('shareId')
      if (accesstoken) {
        localStorage.setItem('tokenPfa', accesstoken + '')
        getIssueTokenByxwzy({
          accesstoken,
          shareId
        }).then(issueRes => {
          return getTokenByxwzy({
            token: issueRes.access_token
          })
        }).then(res => {
          localStorage.setItem('expirationTime', res.data.expirationTime)
          Vue.ls.set(ACCESS_TOKEN, res.data.token)
          ensureSharePermissionAndNext()
        }).catch((err) => {
          Dialog({ message: err.msg, showConfirmButton: false })
        })
      } else {
        redirectToWxAuth(to.fullPath)
      }
    }
  } else if (Vue.ls.get(ACCESS_TOKEN)) {
    // entrance,shareId 有值但 channel 无值时，直接给 to.query 补上 channel
    if (WHITE_PATHS_BY_SHARE.indexOf(to.path) !== -1 && to.query.entrance && to.query.shareId && !to.query.channel) {
      to.query.channel = to.query.entrance
    }
    if (store.getters.permissionList.length === 0) {
      store.dispatch('GetPermissionList').then(res => {
        const menuData = res
        if (menuData === null || menuData === '' || menuData === undefined) {
          return
        }
        let constPermiss = generateRouter(menuData)

        // 添加主界面路由
        store.dispatch('UpdateAppRouter', constPermiss).then(() => {
          // 根据roles权限生成可访问的路由表
          // 动态添加可访问路由表
          store.getters.addRouters.forEach(Router => {
            router.addRoute(Router)
          })
          const redirect = decodeURIComponent(from.query.redirect || to.path)
          if (to.path === redirect) {
            next({ ...to, replace: true })
          } else {
            // 跳转到目的路由
            next({ path: redirect })
          }
        })
      }).catch((err) => {
        // alert('error', err)
        console.log('error', err)
        // 获取授权失败，建议重新登录
        // window.location.href = loginAuthUrl
      })
    } else {
      let qr = getUrlParms('qr')
      if (qr) {
        let newUrl = `${window.location.pathname}${window.location.search}`.replace('qr', 'qr_false')
        // 前端直接跳转微信授权，传入修改后的URL
        redirectToWxAuth(newUrl)
      } else {
        const userInfo = Vue.ls.get(USER_INFO) ? Vue.ls.get(USER_INFO) : {}
        if (to.query.shareColl) {
          next({
            path: '/questionIndex',
            query: {
              userId: to.query.userId,
              mainId: to.query.mainId,
              sharetimes: to.query.sharetimes,
              sourceShare: to.query.sourceShare,
            }
          })
        // } else if ((to.path === '/subject' || to.path === '/questionDetails') && to.query.bankShare) {
        } else if ((to.path === '/subject' || to.path === '/questionDetails') && to.query && to.query.sourceShare) {
          let params = {
            classCode: to.query.classCode,
            difficultyLevel: to.query.difficultyLevel,
            iepUserId: userInfo.id
          }
          if (!(to.query && to.query.isColl) && !(to.query && to.query.isErr)) {
            getUnlock(params).then(res => {
              if (res.data) {
                next()
              } else {
                next({
                  path: '/disease',
                  query: {
                    userId: to.query.userId,
                    mainId: to.query.mainId,
                    sharetimes: to.query.sharetimes,
                    sourceShare: to.query.sourceShare,
                  }
                })
              }
            })
          } else {
            next()
          }
        } else if (to.query && to.query.areaId && to.path !== '/RTCZone/sign') {
          roleDetails({
            areaId: to.query.areaId,
            userId: userInfo.id
          }).then(res => {
            sessionStorage.setItem('roleResult', JSON.stringify(res.data))
            if (`${userInfo.memberType}` === '0' && `${res.data.studentSign}` === '0' && `${res.data.tutorSign}` === '0' && `${res.data.peSign}` === '0' && to.path !== '/RTCZone/sign') {
              next({
                path: '/RTCZone/sign',
                query: {
                  areaId: res.data.areaId
                }
              })
            } else {
              next()
            }
          }).catch(err => {
            console.log(err)
            next()
          })
        } else if (to.query && to.query.campId && to.path !== '/trainingDetail') {
          let campId = to.query.campId
          getTrainingDetails({
            campId
          }).then(res => {
            if (`${res.data.campStatus}` === '3' && `${res.data.joinSign}` === '0') {
              next({
                path: '/trainingDetail',
                query: {
                  campId
                }
              })
              return
            }
            if (`${res.data.campStatus}` === '3' && `${res.data.joinSign}` === '1') {
              next()
              return
            }
            if (to.path === '/trainEvaluate') {
              next()
              return
            }
            if (`${res.data.campStatus}` === '3') {
              next({
                path: '/trainNone',
                query: {
                  type: 'isDone'
                }
              })
            } else if (`${res.data.joinSign}` === '0') {
              next({
                path: '/trainingDetail',
                query: {
                  campId
                }
              })
            } else {
              next()
            }
          })
        } else if (gradePath.includes(to.path) && !isGradeCheck) {
          handleRoute(to, next, userInfo)
        } else if (cjInterceptPath.includes(to.path) && to.query && to.query.sharetimes) {
          next({
            path: '/cartoDate',
            replace: true
          })
        } else if ((to.path === '/kdSimulator' || to.path === '/JJMC_ECGenius') && loginResult.userIdentity && loginResult.userIdentity.veevaStatus === '待验证' && loginResult.userIdentity.isDueDate) {
          next({
            path: '/home',
            replace: true
          })
        } else {
          next()
        }
      }
    }
    if (!sessionStorage.getItem('gradeRolesList')) {
      // typeCode   =  CLASS_OPEN_EDITOR    班级开班/cj编辑角色列表  取对象code字段
      // typeCode   =  CLASS_SELECT_ADMIN   班级管理员/cj查看角色列表  取对象code字段
      // typeCode   =  SIMULATION_PRACTICE_USERS   模拟实操使用者 取对象code字段
      // 同一角色不同权限会在不同列表里
      let params = {
        typeCodeList: ['CLASS_OPEN_EDITOR', 'CLASS_SELECT_ADMIN'],
        dataStatus: '1'
      }
      dictionaryList(params).then(res => {
        if (res.code === 0) {
          let dataObj = {
            EDITORROLES: res.data.filter(item => item.typeCode === 'CLASS_OPEN_EDITOR').map(item => item.code),
            ADMINROLES: res.data.filter(item => item.typeCode === 'CLASS_SELECT_ADMIN').map(item => item.code),
          }
          sessionStorage.setItem('gradeRolesList', JSON.stringify(dataObj))
        }
      }).catch()
    }
  } else {
    // 不在白名单，也没有token，跳转微信授权
    // 传入目标路径，确保分享链接等能正确保存
    redirectToWxAuth(to.fullPath)
  }
})

router.afterEach((to, from) => {
  // }
  // window.__wxjs_is_wkwebview
  // true 时 为 IOS 设备
  // false时 为 安卓 设备
  if (window.entryUrl === '' || window.entryUrl === undefined) {
    var url = `${process.env.baseURL}${process.env.BASE_URL}${to.fullPath}`
    window.entryUrl = url // 将后面的参数去除
  }
  let iepLoginId = getUrlParms('iepLoginId')
  if (!iepLoginId) {
    setTimeout(function () {
      if (!SHARE_PATH.includes(to.path)) {
        let params = {
          title: 'iEP-中国电生理术者充电站',
          titleTimeLine: 'iEP-中国电生理术者充电站',
          desc: '更智慧、更全面、更懂你。',
          link: window.location.href,
          linkTimeLine: window.location.href,
          images: `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
        }
        if (window.location.href.indexOf('trainingList') > -1) {
          params.title = 'iEP-训练营'
          params.desc = '学习电生理，训练营等你！'
          params.titleTimeLine = 'iEP-训练营'
          params.images = `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`
        }
        if (sessionStorage.getItem('roleResult')) {
          let roleResult = JSON.parse(sessionStorage.getItem('roleResult'))
          params.title = roleResult && roleResult.subjectName ? roleResult.subjectName : 'iEP-RTC专区'
          params.desc = roleResult.hospitalName ? `RTC专区：${roleResult.hospitalName}` : ''
          params.titleTimeLine = roleResult.subjectName ? roleResult.subjectName : 'iEP-RTC专区'
          params.images = `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`
        }
        getShareInfo(params)
      }
      sessionStorage.removeItem('isGradeCheck')
    }, 500)
  }

  if (to.path === '/technologyIndex') {
    window.document.title = '新技术'
  } else {
    window.document.title = 'iEP-中国电生理术者充电站'
  }

  const shareMainIdMap = {
    '/courserDetails': to.query.courseId,
    '/technologyDetail': to.query.fileId,
    '/articleDetails': to.query.id,
    '/journalArticle': to.query.articleId,
    '/liveDetails': to.query.liveId,
  }
  // 自定义分享白名单页进入埋点（独立：走 logs/type/2，不走 sourceShare / trackPageView）
  const isShareInit167 = WHITE_PATHS_BY_SHARE_INIT.indexOf(to.path) !== -1 && to.query.entrance == 167
  const isShareInit168 = WHITE_PATHS_BY_SHARE_INIT_168.indexOf(to.path) !== -1 && to.query.entrance == 168
  if (isShareInit167 || isShareInit168) {
    const userInfo = Vue.ls.get(USER_INFO) || {}
    const shareEnterParams = {
      sessionId: '',
      moduleName: (to.meta && to.meta.moduleName) || to.name,
      pageId: to.fullPath,
      pageName: to.name,
      referrerId: from.fullPath || to.fullPath,
      duration: 1,
      incidentType: '2',
      url: to.fullPath,
      urlPath: to.path,
      triggerTime: getDate(new Date().getTime()),
      userId: userInfo.id,
      serviceId: shareMainIdMap[to.path] || '',
      entrance: to.query.entrance || '',
      campId: to.query.businessId || '',
      channel: to.query.channel || '',
      shareId: to.query.shareId || '',
    }
    if (shareEnterParams.userId) {
      // 首次进入时 /api/session 异步写入 sessionId，等有了再上报
      const reportShareEnter = (retry) => {
        const sessionId = window && localStorage.getItem('sessionId')
        if (sessionId) {
          shareEnterParams.sessionId = sessionId
          traceApi(shareEnterParams).then()
        } else if (retry < 50) {
          setTimeout(() => reportShareEnter(retry + 1), 100)
        }
      }
      reportShareEnter(0)
    }
  }

  // 二维码扫进来才轮询 logs/share。离开页面在 beforeEach 里停
  const isShareInit180 = WHITE_PATHS_BY_SHARE_INIT_180.indexOf(to.path) !== -1 && to.query.entrance == 180
  if (isShareInit180) {
    const liveShareUser = Vue.ls.get(USER_INFO) || {}
    if (liveShareUser.id) {
      const lasterStartTime = new Date().getTime()
      const reportLiveShare = (retry) => {
        if (router.currentRoute.fullPath !== to.fullPath) return
        const sessionId = window && localStorage.getItem('sessionId')
        if (sessionId) {
          startLiveShareLog(to, lasterStartTime, shareMainIdMap[to.path])
        } else if (retry < 50) {
          setTimeout(() => reportLiveShare(retry + 1), 100)
        }
      }
      reportLiveShare(0)
    }
  }
})



// WEBPACK FOOTER //
// ./src/permission.js